import { useMe } from "../../lib/auth";
import { useChangelogApp } from "./api";
import "./newdot.css";

/** Stip bij Hulp als er een update is van na de laatste keer kijken (docs/HELPCENTER.md §6). */
export function NewDot() {
  const { data: me } = useMe();
  const q = useChangelogApp(Boolean(me));
  if (!q.data?.unseen) return null;
  return (
    <span className="newdot" data-testid="help-newdot">
      <span className="sr-only">(nieuwe updates)</span>
    </span>
  );
}
